'use client'
import styled from "styled-components";
import {Black, hover, primary} from "@/styles/globalStyleVars";
import {Col, Container, Row} from "react-bootstrap";
import Title from "@/components/Title";
import Link from "next/link";
import {useEffect} from "react";
import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";
import {ScrollSmoother} from "gsap/ScrollSmoother";
import {ScrollToPlugin} from "gsap/ScrollToPlugin";
gsap.registerPlugin(ScrollTrigger, ScrollSmoother, ScrollToPlugin);


const MyComponent = ({pdTop,sectionId,title,data}) => {
    useEffect(() => {
        if (typeof window !== 'undefined') {
            window.scroll(0, 0);
        }
    }, []);

    useEffect(() => {
        if (typeof window !== 'undefined' && window.location.hash) {
            const targetElement = document.querySelector(window.location.hash);
            const topPx = targetElement?.offsetTop;
            console.log(topPx);
            if (targetElement) {
                gsap.to(window, {
                    duration: 0.8,
                    scrollTo: topPx
                });
            }
        }
    }, [typeof window !== 'undefined' && window.location.hash]);
    return (
        <StyledComponent className={`download-list ${pdTop} `} id={`${sectionId}`} >
            <Container>
                <Row>
                    <Col>
                        <Title text={title} margin={'0 0 40px 0'} fontSize={'40'} lineHeight={'50'} />
                    </Col>
                </Row>
                <Row>
                    {
                        data && data?.length >0 &&
                        data?.map((item, index) =>{
                            return(
                                <Col md={6} key={index}>
                                    <div className="download-list-item">
                                        <p>{item?.short_title}</p>
                                        <div className="download-btn">
                                            <Link href={item?.full_path} target={'_blank'}>
                                                <img src="/images/static/Download.svg" alt=""/>
                                            </Link>
                                        </div>
                                    </div>
                                </Col>
                            )
                        })
                    }

                </Row>
            </Container>
        </StyledComponent>
    );

};

const StyledComponent = styled.section`
    background-color: #ffffff;
    .download-list-item{
        display: flex;
        justify-content: space-between;
        background-color: #F9F9F9;
        align-items: center;
        padding-left: 30px;
        border-radius: 5px;
        .download-btn{
            min-width: 60px;
            height: 60px;
            background-color: ${hover};
            display: flex;
            justify-content: center;
            align-items: center;
            position: relative;
            border-radius: 0 5px 5px 0;
            img{
                position: relative;
                z-index: 2;
            }
            a{
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
                
            }
            &:before{
                position: absolute;
                content: '';
                bottom: 0;
                left: 0;
                height: 0;
                width: 100%;
                background-color: ${primary};
                transition: 0.5s ease-in-out;
                border-radius: 0 5px 5px 0;
            }
            
            &:hover{
                &:before{
                    height: 100%;
                }
            }
        }
    }
    
    .col-md-6{
        margin-bottom: 30px;
    }
    
    @media(max-width: 768px){
        .download-list-item{
           padding-left: 15px; 
        }
        h2{
            font-size: 26px !important;
            line-height: 36px !important;
        }
    }
    
`;

export default MyComponent;
